import * as K from './FranchisesConstants';
import Fuse from 'fuse.js';

import floopback from '../../../lib/floopback';
var Franchises = new floopback('franchises');

export function find(params) {
  console.log('params', params);
  let _this = this;
  return (dispatch, getState) => {
    dispatch({
      type: K.FIND,
      payload: Franchises.find(params),
    }).then(function (result) {
      dispatch(searchTable(getState().Franchises.search));
    });
  };
}

export function findById(id) {
  return (dispatch, getState) => {
    dispatch({
      type: K.FIND_BY_ID,
      payload: Franchises.findById(id),
    });
  };
}

export function create(formData) {
  return (dispatch, getState) => {
    return new Promise(function (resolve, reject) {
      dispatch({ type: K.CREATE + '_PENDING', payload: formData });
      Franchises.create(formData)
        .then(function (data) {
          dispatch({ type: K.CREATE + '_FULFILLED', payload: data });
          resolve(data);
        })
        .catch(function (error) {
          dispatch({ type: K.CREATE + '_REJECTED', payload: error });
          reject(error);
        });
    });
  };
}

export function update(id, formData) {
  return (dispatch, getState) => {
    return new Promise(function (resolve, reject) {
      dispatch({ type: K.UPDATE + '_PENDING', payload: formData });
      Franchises.update(id, formData)
        .then(function (data) {
          dispatch({ type: K.UPDATE + '_FULFILLED', payload: data });
          resolve(data);
        })
        .catch(function (error) {
          dispatch({ type: K.UPDATE + '_REJECTED', payload: error });
          reject(error);
        });
    });
  };
}

export function remove(id) {
  return (dispatch, getState) => {
    return new Promise(function (resolve, reject) {
      dispatch({ type: K.DELETE + '_PENDING' });
      Franchises.delete(id)
        .then(function (data) {
          dispatch({ type: K.DELETE + '_FULFILLED', payload: data });
          resolve(data);
        })
        .catch(function (error) {
          dispatch({ type: K.DELETE + '_REJECTED', payload: error });
          reject(error);
        });
    });
  };
}

export function changeTable(feature, value) {
  return (dispatch, getState) => {
    dispatch({
      type: K.CHANGE_TABLE,
      payload: {
        feature: feature,
        value: value,
      },
    });
  };
}

export function searchTable(search) {
  return (dispatch, getState) => {
    const allData = getState().Franchises.data;
    const activeData = allData.filter(item => !item.archived);

    if (!search) {
      return dispatch({
        type: K.SEARCH_TABLE,
        payload: { search: '', searchData: activeData },
      });
    }

    var options = {
      threshold: 0.4,
      location: 0,
      distance: 100,
      maxPatternLength: 32,
      minMatchCharLength: 1,
      keys: ['name', 'owner', 'phone', 'email'],
    };

    var fuse = new Fuse(activeData, options);
    let result = fuse.search(search);

    dispatch({
      type: K.SEARCH_TABLE,
      payload: { search, searchData: result },
    });
  };
}



// WEBPACK FOOTER //
// ./src/views/Franchises/redux/FranchisesActions.jsx